import { FC, useEffect, useState } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { observer } from 'mobx-react-lite';
import {
  Container,
  Grid,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { LeftTabsBlock } from 'components/DashBoardBlocks';
import { FreeTrialPopUp } from 'components/PopUps/FreeTrialPopUp';
// import { handleCompanyUrl } from 'utils/organizationUtils';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import axios from 'server';
import { PasswordUpdateDialog } from 'components/Dialogs';
const Dashboard: FC = observer(() => {
  const classes = useStyles();
  const [openFreeTrialPopUp, setOpenFreeTrialPopUp] = useState<boolean | undefined>(undefined);
  const [openPasswordPopup, setOpenPasswordPopup] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const {
    dashboardStore: { generalStatistic, getStatistic },
    userStore: { user, getProfile },
    notificationStore: { openNotification },
  } = useStore();

  const handleCloseFreeTrialPopUp = () => {
    setOpenFreeTrialPopUp(false);
  };

  const handleClosePasswordPopup = () => {
    setOpenPasswordPopup(false);
    setPassword('');
    setConfirmPassword('');
    setShowPassword(false);
    setShowConfirmPassword(false);
    localStorage.setItem('Password', 'true');
  };

  const handleSavePassword = async () => {
    if (password !== confirmPassword) {
      openNotification('error', 'Passwords do not match');
      return;
    }
    if (password.length < 6) {
      openNotification('error', 'Password must be at least 6 characters');
      return;
    }

    try {
      await axios.post('auth/password/change', {
        password: password,
        password_confirmation: confirmPassword,
      });
      localStorage.setItem('Password', 'true');
      openNotification('success', 'Password saved successfully');
      handleClosePasswordPopup();
    } catch (error: any) {
      openNotification('error', error.response?.data?.message || 'Failed to save password');
    }
  };
  const getStatisticReq = useQuery('getStatisticReq', () => getStatistic(), {
    onError: () => openNotification('error', `Can't get statistic`),
  });
  // const profile = JSON.parse(localStorage.getItem('Profile') as string);
  // const isEndUser = profile?.permission === 'EndUser';
  // const isFirstLogin = localStorage.getItem('isFirstLogin');
  // useQuery('portalSettingsgetReq', () => portalSettingsget(), {
  //   // onError: () => openNotification('error', `Can't get data`),
  //   enabled: !isFirstLogin || !isEndUser,
  // });
  // useQuery('getSyncsReq', () => getSync(), {
  //   onError: () => openNotification('error', `Can't get Sync`),
  //   enabled: !isFirstLogin,
  // });
  // useQuery('getUsersReq', () => getUsers(), {
  //   // onError: () => openNotification('error', `Can't get users`),
  //   enabled: !isFirstLogin,
  // });
  // useQuery('getGroupsReq', () => getGroups(), {
  //   // onError: () => openNotification('error', `Can't get users`),
  //   enabled: !isFirstLogin,
  // });
  // useQuery('getDepartmentReq', () => getDepartments(), {
  //   // onError: () => openNotification('error', `Can't get users`),
  //   enabled: !isFirstLogin,
  // });
  const history = useHistory();
  const getProfileReq = useQuery(
    'getProfileInitialReq',
    () => {
      localStorage.length !== 0 && user?.organizationName !== null && window.location.pathname !== '/' && getProfile();
    },
    {
      enabled: false,
      onError: (error: any) => {
        openNotification('error', `Can't get user profile`);
      },
    }
  );
  // const googleConnectedReq = useQuery('googleConnectedReq', () => googleConnected(), {
  //   onError: () => openNotification('error', `We are unable to connect with Google`),
  // });
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const tokenFromUrl = urlParams.get('token');
  //   if (tokenFromUrl) {
  //     localStorage.setItem('token', `Bearer ${tokenFromUrl}`);
  //     window.history.replaceState({}, document.title, window.location.pathname);
  //   }

  //   getProfile();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const profileFromStorage = JSON.parse(localStorage.getItem('Profile') || 'null');

  useEffect(() => {
    if (profileFromStorage?.password_status === false) {
      setPasswordDialogOpen(true);
    }
  }, [profileFromStorage]);
  // const [data, setData] = useState<any>({});
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userDataFromUrl = urlParams.get('userData');
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      localStorage.setItem('token', `Bearer ${tokenFromUrl}`);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    if (userDataFromUrl) {
      try {
        const parsedUserData = JSON.parse(decodeURIComponent(userDataFromUrl));
        localStorage.setItem('Profile', JSON.stringify(parsedUserData));
        // setData(parsedUserData);
      } catch (error) {
        localStorage.setItem('profile', userDataFromUrl);
        // setData(userDataFromUrl);
      }
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const passwordItem = localStorage.getItem('Password');
    if (passwordItem !== null) {
      const passwordSet = JSON.parse(passwordItem);
      if (passwordSet === false) {
        setOpenPasswordPopup(true);
      }
    }
  }, [user]);
  useEffect(() => {
    document.title = 'EasyIdentity: Admin Dashboard';
    setOpenFreeTrialPopUp(user?.promptMessage === true);
  }, [history, user?.organizationName, user?.promptMessage]);

  useAppPreloader(getProfileReq.isFetching || getStatisticReq.isFetching);
  return !getProfileReq.isFetching ? (
    <>
      <Container maxWidth='xl' className={classes.container}>
        {user?.promptMessage === true && (
          <div className={classes.alert}>
            Thank you for registering for your Free-Trial. We are processing your request. We will notify you when your
            Account is fully-activated. This should happen within one business day. In the meantime, please feel free to
            browse the different features and capabilities of the product. However, please note that some of the
            features may not be available until your account is fully activated.
          </div>
        )}
        <Grid className={classes.infoContainer} container alignItems='stretch' spacing={3}>
          <Grid item xs={2}>
            <Paper className={classes.gridPaper}>
              <p className={classes.value}>{generalStatistic?.usedAccounts || '0'}</p>
              <p className={classes.title}>
                {' '}
                Accounts
                <br />
                Provisioned{' '}
              </p>
              <Link to={'/'} className={classes.link}></Link>
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Paper className={classes.gridPaper}>
              <p className={classes.value}>{generalStatistic?.leftAccounts || '0'}</p>
              <p className={classes.title}>
                Accounts <br /> Remaining
              </p>
              <Link to={'/'} className={classes.link}></Link>
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Paper className={classes.gridPaper}>
              <p className={classes.value}>
                {generalStatistic?.freeTier === 'yes' ? 'FREE-TIER' : generalStatistic?.leftSubscriptionDays || '0'}
              </p>
              <p className={classes.title}>
                {' '}
                {generalStatistic?.freeTier === 'yes' ? (
                  'Limited to 10 Accounts'
                ) : (
                  <>
                    {' '}
                    Days until <br /> Renewal{' '}
                  </>
                )}
              </p>
              <Link to={'/'} className={classes.link}></Link>
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Paper className={classes.gridPaper}>
              <p className={classes.value}>{generalStatistic?.appProvisioned || '0'}</p>
              <p className={classes.title}>
                {' '}
                Apps Available <br /> Provisioned
              </p>
              <Link to={'/'} className={classes.link}></Link>
            </Paper>
          </Grid>
          <Grid item xs={2}>
            <Paper className={classes.gridPaper}>
              <p className={classes.value}>{generalStatistic?.deviceDetected || '0'}</p>
              <p className={classes.title}>
                {' '}
                Devices <br /> Detected{' '}
              </p>
              <Link to={'/'} className={classes.link}></Link>
            </Paper>
          </Grid>
        </Grid>
        <LeftTabsBlock />
      </Container>
      {openFreeTrialPopUp !== undefined ? (
        <FreeTrialPopUp open={openFreeTrialPopUp} handleClose={handleCloseFreeTrialPopUp} />
      ) : (
        ''
      )}

      <Dialog open={openPasswordPopup} onClose={handleClosePasswordPopup} maxWidth='sm' fullWidth>
        <DialogTitle>
          As this is your first login, please set your password. You can also do this later by clicking your profile
          icon in the top-right corner and selecting <b> Change Password. </b>{' '}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin='normal'
            label='Password'
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            margin='normal'
            label='Confirm Password'
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePasswordPopup} color='secondary'>
            Cancel
          </Button>
          <Button onClick={handleSavePassword} color='primary' variant='contained'>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <PasswordUpdateDialog openModal={passwordDialogOpen} handleClose={() => setPasswordDialogOpen(false)} />
    </>
  ) : null;
});

export default Dashboard;
